// ─── Vendor Payment Methods ─────────────────────────────────────────────────
/** The ways a vendor can be paid. Each carries its own required details. */
export var VendorPaymentMethodType;
(function (VendorPaymentMethodType) {
    VendorPaymentMethodType["ZELLE"] = "ZELLE";
    VendorPaymentMethodType["VENMO"] = "VENMO";
    VendorPaymentMethodType["WIRE_ACH"] = "WIRE_ACH";
    VendorPaymentMethodType["PAYPAL"] = "PAYPAL";
    VendorPaymentMethodType["CASH_APP"] = "CASH_APP";
    /** A paper check, mailed to the vendor's address. */
    VendorPaymentMethodType["CHECK"] = "CHECK";
})(VendorPaymentMethodType || (VendorPaymentMethodType = {}));
//# sourceMappingURL=vendor.js.map